<template>
    <BasePanel 
        headline="lang_ERP_INVOICES_CAPTION_INVOICEROWS"
        >
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                hide-default-footer
                :items-per-page="990"
                :items="items"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.title`]="{ item }">
                    <div v-if="item.connectionId != null" 
                        :alvqa="alvqa + 'invoice-row-' + item.connectionId + '-product-title'">
                        <BaseIcon  
                            :icon="getIconOfType(item.type)" 
                            :tooltipText="getIconTooltipText(item)"
                            :alvqa="alvqa + '-icon'"
                        />
                        {{ item.title }}
                    </div>
                    <div v-else :alvqa="alvqa + 'invoice-row-' + item.title.replace(/[^A-Z0-9]+/ig, '-').toLowerCase() + '-freetext'">
                        <BaseIcon  
                            :icon="getIconOfType(item.type)" 
                            :tooltipText="getIconTooltipText(item)"
                            :alvqa="alvqa + '-icon'"
                        />
                        {{ item.title }}
                    </div>
                </template> 

                <template v-slot:[`item.productId`]="{ item }">
                    <div :alvqa="alvqa + 'invoice-row-' + item.connectionId + '-product-id'">
                        {{ $alvPlugin.getProductItemId(item) }}
                    </div>
                </template> 

                <template v-slot:[`item.batch`]="{ item }">
                    <div :alvqa="alvqa + 'invoice-row-' + item.connectionId + '-batch'">
                        {{ $t(getLangOfBatch(item.batch)) }}
                    </div>
                </template>  

                <template v-slot:[`item.quantity`]="{ item }">
                    <div :alvqa="alvqa + 'invoice-row-' + item.connectionId + '-quantity'">
                        {{ item.quantity }}
                    </div>
                </template> 

                <template v-slot:[`item.price`]="{ item }">
                    <div :alvqa="alvqa + 'invoice-row-' + item.connectionId + '-price'">
                        <i18n-n v-if="item.price != null" :value=item.price format="number"></i18n-n>
                    </div>
                </template>

                <template v-slot:[`item.sum`]="{ item }">
                    <div :alvqa="alvqa + 'invoice-row-' + item.connectionId + '-sum'">
                        <i18n-n v-if="item.sum != null" :value=item.sum format="number"></i18n-n>
                    </div>
                </template>

                <template v-slot:[`item.vat`]="{ item }">
                    <div :alvqa="alvqa + 'invoice-row-' + item.connectionId + '-vat'">
                        <i18n-n v-if="item.vat != null" :value=item.vat format="number"></i18n-n>
                    </div>
                </template>

                <template slot="body.append">
                    <tr>
                        <td></td> 
                        <td></td> 
                        <td align="left" class="data-table-sum-row">{{ $t('lang_GENERIC_CAPTION_SUM') }}</td>
                        <td align="right" class="data-table-sum-row">{{ sumField('quantity') }}</td>
                        <td></td>
                        <td align="right" class="data-table-sum-row">{{ sumFieldFloat('sum') }}</td>
                        <td></td>
                    </tr>
                </template>

            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import { DropdownErpShippingBatches } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "InvoiceRowsReadOnlyPanel",
    components: {
        BasePanel,
        BaseIcon,
    },
    props:{
        alvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: "erp-invoices-list-row-" + this.alvId + "-read-only-panel-invoice-rows-"
        }
    },
    methods: { // sum-up values based on name of the column, e.g. for invoice row Sums of Quantity and Money
        sumField(column) {
            return this.$n(this.items.reduce((a, b) => a + (b[column] || 0), 0), 'numberInteger')
        },
        sumFieldFloat(column) {
            return this.$n(this.items.reduce((a, b) => a + (b[column] || 0), 0), 'number')
        },
        getLangOfBatch(selection) {
            if (selection) {
                return DropdownErpShippingBatches.find(obj => {
                    return obj.value == selection
                }).text
            } else return ""
        },
        getIconOfType(type) {
            return this.$alvPlugin.getIconOfType(type)
        },
        getIconTooltipText(item) {
            return this.$alvPlugin.getIconTooltipText(item)
        },
        getProductItemId(item) { 
            return this.$alvPlugin.getProductItemId(item)
        },
    },
    computed: {
        items() { 
            // TODO_PT: remove those two lines, also for readonly not just for edit?
            let item = this.$store.getters.getExpandedInvoices.find(element => {
                return element.alvId === this.alvId
            })
            let alternativeTitles = item.invoiceRows === null ? [] : item.invoiceRows
            return alternativeTitles 
        },
        headers() {
            return [
                {   text: this.$t('lang_ERP_INVOICES_CAPTION_ITEM_TITLE'), 
                    alvqa: this.alvqa + "header-item-title",
                    align: "left", 
                    sortable: false, 
                    value: "title", 
                    tooltip:"", 
                    class: 'text-no-wrap'},

                {   text: this.$t('lang_GENERIC_CAPTION_ID'), 
                    alvqa: this.alvqa + "header-id",
                    align: "left", 
                    sortable: false, 
                    value: "productId", 
                    tooltip:"", 
                    width: "150px"},

                {   text: this.$t('lang_ERP_SHIPPING_CAPTION_BATCH'), 
                    alvqa: this.alvqa + "header-batch",
                    align: "left", 
                    sortable: false, 
                    value: "batch", 
                    tooltip:"", 
                    width: "100px"},

                {   text: this.$t('lang_ERP_INVOICES_CAPTION_QUANTITY'), 
                    alvqa: this.alvqa + "header-quantity",
                    align: "right",
                    sortable: false,
                    value: "quantity",
                    tooltip:"",
                    width: "80px"},

                {   text: this.$t('lang_ERP_INVOICES_CAPTION_ITEM_PRICE') + ' ' + this.$store.getters.getInvoicesDetailsCurrency,
                    alvqa: this.alvqa + "header-item-price",
                    align: "right",
                    sortable: false,
                    value: "price",
                    tooltip:"",
                    width: "150px"},

                {   text: this.$t('lang_ERP_INVOICES_CAPTION_SUM_NET') + ' ' + this.$store.getters.getInvoicesDetailsCurrency,
                    alvqa: this.alvqa + "header-sum-net",
                    align: "right",
                    sortable: false,
                    value: "sum",
                    tooltip:"",
                    width: "150px"},

                {   text: this.$t('lang_GENERIC_CAPTION_VAT') + ' %', 
                    alvqa: this.alvqa + "header-vat", 
                    align: "right",
                    sortable: false,
                    value: "vat",
                    tooltip:"",
                    width: "80px"}
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    }
    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>